import {ResourceEntityCategory} from "./ResourceEntityCategory";

export enum ResourceEntityType {
  Location = "location",
  Person = "person",
  Organization = "organization",
  Misc = "misc",
  Time = "time",
  Date = "date",
  Percent = "percent",
  Money = "money",
  Event = "event",                    // AWS
  Title = "title",                    // AWS
  SSN = "social security number",
  CreditCard = "credit card",
  Email = "email address",
  Phone = "phone"
}

export class ResourceEntityTypeUtils {
  public static ResourceEntityTypes = [
    {id: ResourceEntityType.Location, name: "Location", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Person, name: "Person", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Organization, name: "Organization", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Time, name: "Time", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Date, name: "Date", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Percent, name: "Percent", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Money, name: "Money", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Event, name: "Event", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Title, name: "Title", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.Misc, name: "Misc", type: ResourceEntityCategory.SEMANTIC},
    {id: ResourceEntityType.SSN, name: "Social Security Number", type: ResourceEntityCategory.PII},
    {id: ResourceEntityType.CreditCard, name: "Credit Card", type: ResourceEntityCategory.PII},
    {id: ResourceEntityType.Email, name: "Email Address", type: ResourceEntityCategory.PII},
    {id: ResourceEntityType.Phone, name: "Phone Number", type: ResourceEntityCategory.PII}
  ].sort((a, b) => a.name > b.name ? 1 : -1);

  // PII entities are dropped before storage, so they have no Elasticsearch
  // fields and the post-processing metrics endpoints error for them.
  public static SemanticTypes = ResourceEntityTypeUtils.ResourceEntityTypes
    .filter(t => t.type !== ResourceEntityCategory.PII);

  // PII types are only searchable when the project pays for enhanced PII detection.
  public static ForProject(enhancedPiiDetection?: boolean) {
    return enhancedPiiDetection ? ResourceEntityTypeUtils.ResourceEntityTypes : ResourceEntityTypeUtils.SemanticTypes;
  }
}
